import { useEffect, useState } from "react";
import "../parts-list/PartsList.css";
import { FaRegCopy } from "react-icons/fa";
import { FaCheck } from "react-icons/fa";

export const PartsListStructure = ({
  calculatorDataResult,
  systemType,
  language,
}) => {
  const [wallgreenFormDataResult, setWallgreenFormDataResult] = useState(null);
  const [growGreenDataResult, setGrowGreenFormDataResult] = useState(null);
  const [copyIcon, setCopyIcon] = useState(<FaRegCopy />);
  const [copyText, setCopyText] = useState("Quantidade");

  useEffect(() => {
    setWallgreenFormDataResult(calculatorDataResult);
    setGrowGreenFormDataResult(calculatorDataResult);
  }, [calculatorDataResult]);

  // Limpar o estado local quando o systemType mudar
  useEffect(() => {
    setWallgreenFormDataResult(null);
    setGrowGreenFormDataResult(null);
  }, [systemType]);

  // Objeto de tradução para os textos em diferentes idiomas
  const languageTexts = {
    "pt-br": {
      title: "Lista de Componentes Estruturais",
      copyQuantity: "Quantidade",
      copied: "Copiado",
      components: {
        horizontalPlate: "Placa Horizontal",
        verticalPlate: "Placa Vertical",
        wallGreenPot: "Vaso WallGreen",
        wallGreenSubstrateBag: "Bolsa de Substrato Vaso WallGreen",
        growGreenSquarePot: "Vaso Quadrado Grow Green",
        growGreenShell: "Concha Grow Green",
        growGreenMesh: "Tela Grow Green",
        growGreenLockingPin: "Pino de Travamento Concha Grow Green",
        lockingPin: "Pino de Travamento",
        initialFinalFinish: "Acabamento Inicial/Final",
        cuttedNichePlate: "Placa de Nicho Cortada",
        cuttedNicheComplement: "Complemento cortado para Duplo",
        cornerPlate: "Placa de Cantoneira",
        cornerUnion: "União de Cantoneira",
        cornerPot: "Vaso Cantoneira",
        cornerSubstrateBag: "Bolsa de Substrato Cantoneira",
        cornerVerticalPlate: "Placa Vertical Cantoneira",
      },
    },
    en: {
      title: "Structural Components List",
      copyQuantity: "Quantity",
      copied: "Copied",
      components: {
        horizontalPlate: "Horizontal Plate",
        verticalPlate: "Vertical Plate",
        wallGreenPot: "WallGreen Pot",
        wallGreenSubstrateBag: "Substrate Bag WallGreen Pot",
        growGreenSquarePot: "Grow Green Square Pot",
        growGreenShell: "Grow Green Shell",
        growGreenMesh: "Grow Green Mesh",
        growGreenLockingPin: "Locking Pin Grow Green Shell",
        lockingPin: "Locking Pin",
        initialFinalFinish: "Initial/Final Finish",
        cuttedNichePlate: "Cutted Niche Plate",
        cuttedNicheComplement: "Cutted Double Complement",
        cornerPlate: "Corner Plate",
        cornerUnion: "Corner Union",
        cornerPot: "Corner Pot",
        cornerSubstrateBag: "Corner Substrate Bag",
        cornerVerticalPlate: "Corner Vertical Plate",
      },
    },
    es: {
      title: "Lista de Componentes Estructurales",
      copyQuantity: "Cantidad",
      copied: "Copiado",
      components: {
        horizontalPlate: "Placa Horizontal",
        verticalPlate: "Placa Vertical",
        wallGreenPot: "Maceta WallGreen",
        wallGreenSubstrateBag: "Bolsa de Sustrato Maceta WallGreen",
        growGreenSquarePot: "Maceta Cuadrada Grow Green",
        growGreenShell: "Concha Grow Green",
        growGreenMesh: "Malla Grow Green",
        growGreenLockingPin: "Pin de Bloqueo Concha Grow Green",
        lockingPin: "Pin de Bloqueo",
        initialFinalFinish: "Acabado Inicial/Final",
        cuttedNichePlate: "Placa de Nicho Cortada",
        cuttedNicheComplement: "Complemento Cortado para Dobles",
        cornerPlate: "Placa Esquina",
        cornerUnion: "Unión Esquina",
        cornerPot: "Maceta Esquina",
        cornerSubstrateBag: "Bolsa de Sustrato Esquina",
        cornerVerticalPlate: "Placa Vertical Esquina",
      },
    },
  };

  // Obtém os textos correspondentes à linguagem selecionada
  const texts = languageTexts[language] || languageTexts["en"]; // Se a linguagem não for encontrada, usa o inglês como padrão

  const copyToClipboard = () => {
    const textarea = document.createElement("textarea");
    const quantities = document.querySelectorAll(
      ".quantidade-column-structure"
    );

    const quantitiesText = Array.from(quantities)
      .map((quantity) => quantity.textContent)
      .join("\n");

    textarea.value = quantitiesText;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);

    setCopyIcon(<FaCheck />);
    setCopyText(texts.copied);

    // Agendar a reversão do estado após alguns segundos
    setTimeout(() => {
      setCopyIcon(<FaRegCopy />);
      setCopyText(texts.copyQuantity);
    }, 2000); // 2000ms = 2 segundos

    // Adicionar classe para animação
    const thElement = document.querySelector(".parts-list th");
    thElement.classList.add("clicked");
    setTimeout(() => {
      thElement.classList.remove("clicked");
    }, 1000); // Ajuste a duração da animação aqui
  };

  const {
    totalPlacaHorizontal,
    totalPlacaVertical,
    totalPlacaNicho,
    totalPlacaDuplo,
    totalVasos,
    totalBolsasSubstrato,
    totalInicialFinal,
    totalPinoDeTravamento,
    totalPlacaCantoneira,
    totalVasoCantoneira,
    totalUniaoCantoneira,
    totalPlacaVerticalCantoneira,
    totalBolsaSubstratoCantoneira,
  } = wallgreenFormDataResult ? wallgreenFormDataResult : {};

  const {
    totalVasosGrowGreen,
    totalConchaGrowGreen,
    totalTelaGrowGreen,
    totalPinoDaConcha,
  } = growGreenDataResult ? growGreenDataResult : {};

  return (
    <div className="parts-list container">
      <h2>{texts.title}</h2>
      <table>
        <thead>
          <tr>
            <th>Código</th>
            <th>Item</th>
            <th onClick={copyToClipboard}>
              {texts.copyQuantity} {copyIcon}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>100.001.012</td>
            <td>{texts.components.horizontalPlate}</td>
            <td
              className="quantidade-column-structure"
              id="totalPlacaHorizontal"
            >
              {totalPlacaHorizontal}
            </td>
          </tr>
          <tr>
            <td>100.001.002</td>
            <td>{texts.components.verticalPlate}</td>
            <td className="quantidade-column-structure" id="totalPlacaVertical">
              {totalPlacaVertical}
            </td>
          </tr>
          {systemType === "wallgreen" && (
            <>
              <tr>
                <td>100.001.009</td>
                <td>{texts.components.wallGreenPot}</td>
                <td className="quantidade-column-structure" id="totalVasos">
                  {totalVasos}
                </td>
              </tr>
              <tr>
                <td>100.001.011</td>
                <td>{texts.components.wallGreenSubstrateBag}</td>
                <td
                  className="quantidade-column-structure"
                  id="totalBolsaSubstrato"
                >
                  {totalBolsasSubstrato}
                </td>
              </tr>
            </>
          )}
          {systemType === "growgreen" && (
            <>
              <tr>
                <td>100.001.010</td>
                <td>{texts.components.growGreenSquarePot}</td>
                <td className="quantidade-column-structure">
                  {totalVasosGrowGreen}
                </td>
              </tr>
              <tr>
                <td>100.001.018</td>
                <td>{texts.components.growGreenShell}</td>
                <td
                  className="quantidade-column-structure"
                  id="totalBolsaSubstrato"
                >
                  {totalConchaGrowGreen}
                </td>
              </tr>
              <tr>
                <td>100.001.008</td>
                <td>{texts.components.growGreenMesh}</td>
                <td className="quantidade-column-structure">
                  {totalTelaGrowGreen}
                </td>
              </tr>
              <tr>
                <td>100.001.019</td>
                <td>{texts.components.growGreenLockingPin}</td>
                <td className="quantidade-column-structure">
                  {totalPinoDaConcha}
                </td>
              </tr>
            </>
          )}

          <tr>
            <td>100.001.014</td>
            <td>{texts.components.lockingPin}</td>
            <td
              className="quantidade-column-structure"
              id="totalPinoDeTravamento"
            >
              {totalPinoDeTravamento}
            </td>
          </tr>
          <tr>
            <td>100.001.015</td>
            <td>{texts.components.initialFinalFinish}</td>
            <td className="quantidade-column-structure" id="totalInicialFinal">
              {totalInicialFinal}
            </td>
          </tr>
          <tr>
            <td>100.001.031</td>
            <td>{texts.components.cuttedNichePlate}</td>
            <td className="quantidade-column-structure" id="totalPlacaNicho">
              {totalPlacaNicho}
            </td>
          </tr>
          <tr>
            <td>100.001.32</td>
            <td>{texts.components.cuttedNicheComplement}</td>
            <td className="quantidade-column-structure" id="totalPlacaDuplo">
              {totalPlacaDuplo}
            </td>
          </tr>
          {systemType === "wallgreen" && (
            <>
              <tr>
                <td>100.001.003</td>
                <td>{texts.components.cornerPlate}</td>
                <td
                  className="quantidade-column-structure"
                  id="totalPlacaCantoneira"
                >
                  {totalPlacaCantoneira}
                </td>
              </tr>
              <tr>
                <td>100.001.004</td>
                <td>{texts.components.cornerUnion}</td>
                <td
                  className="quantidade-column-structure"
                  id="totalUniaoCantoneira"
                >
                  {totalUniaoCantoneira}
                </td>
              </tr>

              <tr>
                <td>100.001.005</td>
                <td>{texts.components.cornerPot}</td>
                <td
                  className="quantidade-column-structure"
                  id="totalVasoCantoneira"
                >
                  {totalVasoCantoneira}
                </td>
              </tr>
              <tr>
                <td>100.001.006</td>
                <td>{texts.components.cornerSubstrateBag}</td>
                <td
                  className="quantidade-column-structure"
                  id="totalBolsaSubstratoCantoneira"
                >
                  {totalBolsaSubstratoCantoneira}
                </td>
              </tr>
              <tr>
                <td>100.001.007</td>
                <td>{texts.components.cornerVerticalPlate}</td>
                <td
                  className="quantidade-column-structure"
                  id="totalPlacaVerticalCantoneira"
                >
                  {totalPlacaVerticalCantoneira}
                </td>
              </tr>
            </>
          )}
        </tbody>
      </table>
    </div>
  );
};
